<div class="block block-themed block-transparent mb-0">
    <div class="block-header bg-primary-dark">
        <h3 class="block-title">Merge statistics</h3>
        <div class="block-options">
            <button
                type="button"
                class="btn-block-option"
                data-dismiss="modal"
                aria-label="Close"
                (click)="close()"
            >
                <i class="si si-close"></i>
            </button>
        </div>
    </div>
    <div class="block-content">
        <table class="table table-bordered table-striped table-vcenter">
            <tbody>
                <tr>
                    <th>MERGING</th>
                    <td>{{ stats.MERGING }}</td>
                </tr>
                <tr>
                    <th>VALIDATING_SIMPLE</th>
                    <td>{{ stats.VALIDATING_SIMPLE }}</td>
                </tr>
                <tr>
                    <th>VALIDATION_SIMPLE_FAILED</th>
                    <td>{{ stats.VALIDATION_SIMPLE_FAILED }}</td>
                </tr>
                <tr>
                    <th>VALIDATION_SIMPLE_FINISHED</th>
                    <td>{{ stats.VALIDATION_SIMPLE_FINISHED }}</td>
                </tr>
                <tr>
                    <th>GEOLOCATING_SERVICE</th>
                    <td>{{ stats.GEOLOCATING_SERVICE }}</td>
                </tr>
                <tr>
                    <th>VALIDATING_COMPLEX</th>
                    <td>{{ stats.VALIDATING_COMPLEX }}</td>
                </tr>
                <tr>
                    <th>VALIDATION_COMPLEX_FAILED</th>
                    <td>{{ stats.VALIDATION_COMPLEX_FAILED }}</td>
                </tr>
                <tr>
                    <th>VALIDATION_COMPLEX_FINISHED</th>
                    <td>{{ stats.VALIDATION_COMPLEX_FINISHED }}</td>
                </tr>
                <tr>
                    <th>CALCULATE_DISTANCE_SERVICE</th>
                    <td>{{ stats.CALCULATE_DISTANCE_SERVICE }}</td>
                </tr>
                <tr>
                    <th>CALCULATE_DISTANCE_POI</th>
                    <td>{{ stats.CALCULATE_DISTANCE_POI }}</td>
                </tr>
                <tr>
                    <th>CHECK_MISMATCHING_GOOGLEPLACEID_SERVICE</th>
                    <td>{{ stats.CHECK_MISMATCHING_GOOGLEPLACEID_SERVICE }}</td>
                </tr>
                <tr>
                    <th>CHECK_MISMATCHING_GOOGLEPLACEID_SERVICE_FAILED</th>
                    <td>
                        {{
                            stats.CHECK_MISMATCHING_GOOGLEPLACEID_SERVICE_FAILED
                        }}
                    </td>
                </tr>
                <tr>
                    <th>READY_FOR_PROD</th>
                    <td>{{ stats.READY_FOR_PROD }}</td>
                </tr>
                <tr>
                    <th>MOVING_TO_PROD</th>
                    <td>{{ stats.MOVING_TO_PROD }}</td>
                </tr>
                <tr>
                    <th>MOVED_TO_PROD</th>
                    <td>{{ stats.MOVED_TO_PROD }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="modal-footer">
    <button
        type="button"
        class="btn btn-alt-secondary"
        data-dismiss="modal"
        (click)="close()"
    >
        Close
    </button>
</div>
